export default {
  app: {
    title: 'Облікова система',
  },
  nav: {
    section_catalogs: 'Довідники',
    section_documents: 'Документи',
    section_reports: 'Звіти',
    section_closing: 'Закриття',
    home: 'Головна',
    organizations: 'Організації',
    contractors: 'Контрагенти',
    nomenclature: 'Номенклатура',
    goods_receipts: 'Надходження товарів',
    goods_sales: 'Реалізація товарів',
    bank_receipts: 'Банк: надходження',
    bank_payments: 'Банк: списання',
    cash_receipts: 'Каса: ПКО',
    cash_payments: 'Каса: РКО',
    manual_operations: 'Бухгалтерська довідка',
    trial_balance: 'Оборотно-сальдова відомість',
    account_card: 'Картка рахунку',
    subconto_analysis: 'Аналіз субконто',
    goods_balance: 'Залишки на складі',
    month_closing: 'Закриття місяця',
  },
  auth: {
    login: 'Логін',
    password: 'Пароль',
    sign_in: 'Увійти',
    signing_in: 'Вхід…',
    invalid_credentials: 'Невірний логін або пароль',
    logout: 'Вийти',
    welcome: 'Ласкаво просимо',
  },
  common: {
    save: 'Зберегти',
    cancel: 'Скасувати',
    create: 'Створити',
    edit: 'Редагувати',
    delete: 'Видалити',
    search: 'Пошук',
    loading: 'Завантаження…',
    nothing_found: 'Нічого не знайдено',
    yes: 'Так',
    no: 'Ні',
    error: 'Помилка',
    actions: 'Дії',
    confirm_delete: 'Позначити на видалення?',
  },
  org: {
    title: 'Організації',
    new: 'Нова організація',
    code: 'Код',
    name: 'Назва',
    full_name: 'Повна назва',
    edrpou: 'ЄДРПОУ',
    inn: 'ІПН',
    is_vat_payer: 'Платник ПДВ',
    vat_number: 'Номер свідоцтва ПДВ',
    cost_method: 'Метод собівартості',
    tax_system: 'Система оподаткування',
    base_currency: 'Базова валюта',
  },
  contractor: {
    title: 'Контрагенти',
    new: 'Новий контрагент',
    code: 'Код',
    name: 'Найменування',
    full_name: 'Повне найменування',
    type: 'Тип',
    types: {
      LEGAL: 'Юридична особа',
      INDIVIDUAL_FOP: 'ФОП',
      INDIVIDUAL: 'Фізична особа',
      SEPARATE_DIVISION: 'Відокремлений підрозділ',
    },
    edrpou: 'ЄДРПОУ',
    inn: 'ІПН',
    is_vat_payer: 'Платник ПДВ',
    is_buyer: 'Покупець',
    is_supplier: 'Постачальник',
    is_other: 'Інше',
  },
  nom: {
    title: 'Номенклатура',
    new: 'Нова позиція',
    code: 'Код',
    article: 'Артикул',
    name: 'Найменування',
    full_name: 'Повне найменування',
    is_service: 'Послуга',
    is_excise: 'Підакцизний',
    ukt_zed: 'УКТ ЗЕД',
    country: 'Країна походження',
  },
  home: {
    welcome: 'Ласкаво просимо до облікової системи',
    description:
      'Меню зліва: довідники, документи (бухгалтерська довідка), звіти (ОСВ).',
  },
  mo: {
    title: 'Бухгалтерська довідка',
    new: 'Нова бухгалтерська довідка',
    organization: 'Організація',
    number: '№',
    date: 'Дата',
    content: 'Зміст операції',
    posted: 'Проведено',
    posted_yes: 'Проведено',
    posted_no: 'Не проведено',
    entries: 'Проводки',
    dt: 'Дебет',
    cr: 'Кредит',
    amount: 'Сума',
    entry_content: 'Опис рядка',
    total: 'Разом',
    add_row: 'Додати рядок',
    post: 'Провести',
    unpost: 'Розпровести',
  },
  gr: {
    title: 'Надходження товарів',
    new: 'Нове надходження',
    organization: 'Організація',
    number: '№',
    date: 'Дата',
    contractor: 'Постачальник',
    contract: 'Договір',
    warehouse: 'Склад',
    supplier_doc: 'Накладна постачальника',
    items: 'Товари',
    nomenclature: 'Номенклатура',
    qty: 'Кількість',
    price: 'Ціна',
    amount_without_vat: 'Сума без ПДВ',
    vat: 'Ставка ПДВ',
    vat_amount: 'Сума ПДВ',
    total: 'Усього',
    posted: 'Проведено',
  },
  tb: {
    title: 'Оборотно-сальдова відомість',
    organization: 'Організація',
    from: 'З',
    to: 'По',
    code: 'Код',
    account: 'Рахунок',
    opening: 'Сальдо на початок',
    turnover: 'Оборот за період',
    closing: 'Сальдо на кінець',
    dt: 'Дт',
    cr: 'Кт',
    totals: 'Підсумки',
    balanced: 'Дт = Кт',
    not_balanced: 'Дт ≠ Кт — перевірте проводки',
    this_month: 'Поточний місяць',
    refresh: 'Оновити',
  },
  cl: {
    title: 'Закриття місяця',
    year: 'Рік',
    month: 'Місяць',
    income: 'Доходи',
    expenses: 'Витрати',
    code: 'Код',
    account: 'Рахунок',
    amount: 'Сума',
    total_income: 'Усього доходів',
    total_expenses: 'Усього витрат',
    financial_result: 'Фінансовий результат',
    profit: 'прибуток',
    loss: 'збиток',
    nothing: 'немає',
    close_period: 'Закрити період',
    reopen_period: 'Відкрити період',
    period_closed_notice: 'Період закрито. Зміни в документах цього періоду заборонені.',
  },
  ac: {
    title: 'Картка рахунку',
    account: 'Рахунок',
    date: 'Дата',
    doc_type: 'Тип документа',
    doc_number: '№ документа',
    side: 'Стор.',
    corr: 'Кор. рахунок',
    content: 'Зміст',
    amount_dt: 'Дебет',
    amount_cr: 'Кредит',
    running_balance: 'Залишок',
    turnover_dt: 'Оборот Дт',
    turnover_cr: 'Оборот Кт',
  },
  sa: {
    title: 'Аналіз субконто',
    sc_type: 'Тип субконто',
    sc_name: 'Найменування',
  },
  cd: {
    organization: 'Організація',
    number: '№',
    date: 'Дата',
    cash_register: 'Каса',
    operation_type: 'Тип операції',
    contractor: 'Контрагент',
    contract: 'Договір',
    amount: 'Сума',
    basis: 'Підстава',
    party_placeholder: 'ПІБ або найменування (якщо немає в довіднику)',
    posted: 'Проведено',
    ops: {
      FROM_BUYER: 'Від покупця',
      FROM_BANK: 'З банку (зняття)',
      FROM_PODOTCHET: 'Від підзвітної особи',
      LOAN: 'Позика',
      OTHER: 'Інше',
      TO_SUPPLIER: 'Постачальнику',
      TO_BANK: 'У банк (внесення)',
      TO_PODOTCHET: 'У підзвіт',
      SALARY: 'Виплата зарплати',
      LOAN_RETURN: 'Повернення позики',
    },
  },
  cr: {
    title: 'Каса: надходження (ПКО)',
    new: 'Новий ПКО',
    received_from: 'Прийнято від',
  },
  cp: {
    title: 'Каса: списання (РКО)',
    new: 'Новий РКО',
    issued_to: 'Видано',
  },
  bd: {
    organization: 'Організація',
    number: '№',
    date: 'Дата',
    bank_account: 'Розрахунковий рахунок',
    operation_type: 'Тип операції',
    contract: 'Договір',
    amount: 'Сума',
    purpose: 'Призначення платежу',
    posted: 'Проведено',
    ops: {
      FROM_BUYER: 'Від покупця',
      FROM_BANK: 'Від банку',
      LOAN: 'Отримання позики',
      OTHER: 'Інше',
      CARD_RECEIPT: 'Карткою (еквайринг)',
      TO_SUPPLIER: 'Постачальнику',
      TO_BANK: 'У банк',
      TAX: 'Сплата податку',
      SALARY: 'Виплата зарплати',
      LOAN_RETURN: 'Повернення позики',
      CARD_PAYMENT: 'Картковий платіж',
    },
  },
  br: {
    title: 'Банк: надходження',
    new: 'Нове надходження',
    payer: 'Платник',
  },
  bp: {
    title: 'Банк: списання',
    new: 'Нове списання',
    recipient: 'Отримувач',
  },
  gs: {
    title: 'Реалізація товарів',
    new: 'Нова реалізація',
    organization: 'Організація',
    number: '№',
    date: 'Дата',
    contractor: 'Покупець',
    contract: 'Договір',
    warehouse: 'Склад',
    items: 'Товари',
    nomenclature: 'Номенклатура',
    qty: 'Кількість',
    price: 'Ціна',
    amount_without_vat: 'Сума без ПДВ',
    vat: 'Ставка ПДВ',
    vat_amount: 'Сума ПДВ',
    total: 'Усього',
    cost_amount: 'Собівартість',
    posted: 'Проведено',
  },
  gb: {
    title: 'Залишки на складі',
    on_date: 'На дату',
    warehouse: 'Склад',
    warehouse_code: 'Код складу',
    all_warehouses: 'Усі склади',
    code: 'Код',
    article: 'Артикул',
    name: 'Найменування',
    quantity: 'Кількість',
    cost: 'Собівартість',
    unit_cost: 'Ціна одиниці',
    batch_date: 'Дата партії',
    view_summary: 'Зведено',
    view_batches: 'По партіях',
    total_qty: 'Усього кількість',
    total_cost: 'Усього собівартість',
  },
};
